module.exports = __webpack_public_path__ + "img/fpt_logo_2.ce34d151.svg";